function pick<T extends object, K extends keyof T>(obj: T, keys: readonly K[]): Pick<T, K>;
function pick<T extends object>(obj: T | null | undefined, keys: readonly PropertyKey[]): Partial<T>;
function pick(obj: unknown, keys: readonly PropertyKey[]): Record<string, unknown>;
function pick(obj: unknown, keys: readonly PropertyKey[]): Record<string, unknown> {
    const out: Record<string, unknown> = {};
    if (obj == null || typeof obj !== 'object') {
        return out;
    }
    for (const key of keys) {
        if (key in obj) {
            out[key as string] = (obj as Record<string, unknown>)[key as string];
        }
    }
    return out;
}

export default pick;
